import React from "react";
import { Container, Row, col } from "react-bootstrap";
import classes from "./StudentDetailsMobile.module.css";
import { Button } from "../../../../stories/Button/Button";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import {
  coachDemoImg,
  chatSendIcon,
  ChatBlackIcon,
  LocationIconGray,
  CoachHatIcon,
  CancelIconBlack,
} from "../../../../constant/imagePath";
import Ratings from "react-star-ratings";
import { ReactSVG } from "react-svg";
import ModalSkeletonCssClasses from "../../../../components/ModalSkeleton/ModalSkeleton.module.css";
import ModalSkeleton from "../../../../components/ModalSkeleton/ModalSkeleton";

const StudentDetailsMobile = ({ studentDetails, show, setShow }) => {
  console.log("++++++++");
  console.log(studentDetails);
  return (
    <>
      <style>{`
      .${ModalSkeletonCssClasses.body} {
        padding: 0px;
      }
          .modal .modal-dialog {
            width: 100% !important;
            margin: 0px !important;
          }
          .modal .modal-dialog {
            max-width: 100% !important;
            height: 100%;
        }
        .modal-content{
            min-height:100%
        }
        .modal { 
            border-radius: 0px;
            background: white;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        hideHeaderBorder
        borderRadius={"0px"}
        width={"100%"}
      >
        <Container fluid className={["p-0"].join(" ")}>
          <div
            style={{ border: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
            className={[classes.header].join(" ")}
          >
            <ReactSVG
              src={CancelIconBlack}
              className={[classes.cancel].join(" ")}
              onClick={setShow}
            />
            <h6
              style={{
                ...Fonts.b3,
                color: Colors.neutralShadesOfNero,
              }}
            >
              User profile
            </h6>
            <div />
          </div>

          <div className={[classes.middleSection].join(" ")}>
            <div className={[classes.dflex, classes.mb32].join(" ")}>
              <div className={[classes.StudentImg].join(" ")}>
                <img src={studentDetails?.img} alt="..." />
              </div>
              <div className={[classes.studentContentDiv].join(" ")}>
                <div>
                  <p
                    className={[classes.mb6].join(" ")}
                    style={{
                      ...Fonts.h4,
                      color: Colors.neutralShadesOfNero,
                      fontSize: "20px",
                      lineHeight: "28px",
                    }}
                  >
                    {studentDetails?.name}
                  </p>
                  <div className={[classes.starDiv].join(" ")}>
                    <div className={[classes.starInStudentDetails].join(" ")}>
                      <Ratings
                        numberOfStars={1}
                        rating={studentDetails?.rating}
                        starRatedColor={Colors.mainShadeOfRed}
                        starEmptyColor={Colors.neutralShadesOfGainsboro}
                        starDimension="16px"
                      />
                    </div>
                    <p
                      style={{
                        ...Fonts.h8,
                        fontSize: "14px",
                        color: Colors.neutralShadesOfNero,
                        lineHeight: "16px",
                      }}
                      className={[classes.ml8].join(" ")}
                    >
                      {studentDetails?.rating.toFixed(1)}
                    </p>
                    <span
                      style={{
                        backgroundColor: Colors.neutralShadesOfPinkSwan,
                      }}
                      className={[classes.dot].join(" ")}
                    />
                    <p
                      style={{
                        ...Fonts.b3,
                        fontSize: "14px",
                        lineHeight: "16px",
                        color: Colors.neutralShadesOfNero,
                      }}
                    >
                      {studentDetails?.age} years old
                    </p>
                  </div>
                </div>
                <div>
                  <Button label="" primary={false} icon={ChatBlackIcon} />
                </div>
              </div>
            </div>
            <div className={[classes.moreAboutDiv].join(" ")}>
              <p
                style={{
                  ...Fonts.h4,
                  color: Colors.neutralShadesOfNero,
                  fontSize: "20px",
                  lineHeight: "28px",
                }}
                className={[classes.pb8].join(" ")}
              >
                More About {studentDetails?.name.split(" ")[0]}
              </p>
              <p
                style={{
                  ...Fonts.b1Mobile,
                  color: Colors.neutralShadesOfDimGray,
                  fontSize: "16px",
                  lineHeight: "24px",
                }}
              >
                {studentDetails?.aboutMe}
              </p>
            </div>

            <div className={[classes.experienceDiv].join(" ")}>
              <p
                style={{
                  ...Fonts.h4,
                  color: Colors.neutralShadesOfNero,
                  fontSize: "20px",
                  lineHeight: "28px",
                }}
                className={[classes.pb16].join(" ")}
              >
                Experience
              </p>
              <div className={[classes.dflex].join(" ")}>
                {studentDetails?.experience.map((item, i) => {
                  return (
                    <div
                      className={[classes.experienceBox].join(" ")}
                      key={i}
                      style={{
                        border: `1px solid ${Colors.neutralShadesOfWhisper}`,
                      }}
                    >
                      <span
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      >
                        {item?.title}:
                      </span>
                      <span
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfNero,
                        }}
                        className={[classes.pl3].join(" ")}
                      >
                        {item?.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
            {studentDetails?.myCoaches.length > 0 ? (
              <div className={[classes.coachMainDiv].join(" ")}>
                <p
                  style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}
                  className={[classes.pb16].join(" ")}
                >
                  My Coaches
                </p>
                {studentDetails?.myCoaches.map((item, i) => {
                  return (
                    <div
                      className={[classes.coachDiv].join(" ")}
                      key={i}
                      style={{
                        borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
                      }}
                    >
                      <div className={[classes.coachImg].join(" ")}>
                        <img src={item?.img} alt="..." />
                      </div>
                      <div
                        className={[
                          classes.pl16,
                          classes.coachMainContentDiv,
                        ].join(" ")}
                      >
                        <div>
                          <p
                            style={{
                              ...Fonts.h6,
                              color: Colors.neutralShadesOfNero,
                            }}
                            className={[classes.mb4].join(" ")}
                          >
                            {studentDetails?.name}
                          </p>
                          <div className={[classes.coachDetailDiv].join(" ")}>
                            <div
                              style={{
                                ...Fonts.p1,
                                color: Colors.neutralShadesOfDimGray,
                              }}
                              className={[classes.locationIconDiv].join(" ")}
                            >
                              <ReactSVG src={LocationIconGray} />
                              <span className={[classes.ml6].join(" ")}>
                                {item?.location}
                              </span>
                            </div>
                            <span
                              style={{
                                backgroundColor: Colors.neutralShadesOfDimGray,
                              }}
                              className={[classes.dot].join(" ")}
                            />
                            <p
                              style={{
                                ...Fonts.p1,
                                color: Colors.neutralShadesOfDimGray,
                              }}
                            >
                              {item?.sport}
                            </p>
                          </div>
                        </div>
                        <div className={[classes.coachRatingDiv].join(" ")}>
                          <Ratings
                            numberOfStars={1}
                            rating={item?.rating}
                            starRatedColor={Colors.mainShadeOfRed}
                            starEmptyColor={Colors.neutralShadesOfGainsboro}
                            starDimension="16px"
                          />
                          <p
                            style={{
                              ...Fonts.p2,
                              fontSize: "14px",
                              lineHeight: "20px",
                              color: Colors.neutralShadesOfNero,
                            }}
                            className={[classes.ml4].join(" ")}
                          >
                            {item?.rating.toFixed(1)}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className={[classes.noCoachesDiv].join(" ")}>
                <div className={[classes.noCoachesInnerDiv].join(" ")}>
                  <ReactSVG
                    className={[classes.CoachHatImg].join(" ")}
                    src={CoachHatIcon}
                  />
                  <p
                    className={[classes.mb8].join(" ")}
                    style={{
                      ...Fonts.h4,
                      color: Colors.neutralShadesOfNero,
                      fontSize: "20px",
                      lineHeight: "28px",
                    }}
                  >
                    {studentDetails?.name} has no coaches yet
                  </p>
                  <p
                    style={{
                      ...Fonts.p1,
                      color: Colors.neutralShadesOfDimGray,
                      fontSize: "14px",
                    }}
                  >
                    As soon as the student passes the first training session,
                    the coach from whom she passed it will appear here.
                  </p>
                </div>
              </div>
            )}
          </div>
        </Container>
      </ModalSkeleton>
    </>
  );
};
export default StudentDetailsMobile;
